import React, { PropsWithChildren } from "react";
import { useHasPermissions } from "../../hooks/useHasPermissions";
import { EASASPermissionKey } from "../../models/enum/permissions";

type PermissionGuardProps = PropsWithChildren<{
  permissions: EASASPermissionKey | EASASPermissionKey[];
}>;

export function PermissionGuard(props: PermissionGuardProps) {
  const hasPermission = useHasPermissions(props.permissions);

  if (hasPermission) {
    return <>{props.children}</>;
  }

  return <i>{props.permissions} permission(s) required</i>;
}

PermissionGuard.Else = function Else(props: PropsWithChildren<{}>) {
  return <i>{props.children}</i>;
};
